import classnames from 'classnames/bind'
import Pagination from 'entities/pagination'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './pagination_summary.module.scss'

const cx = classnames.bind(styles)

const PaginationSummary = ({ className, pagination, format, emptyMessage }) => {
  const content =
    pagination.totalCount === 0
      ? emptyMessage
      : format
          .replace(/%1\$s/g, pagination.totalCount)
          .replace(/%2\$s/g, pagination.currentStartCount)
          .replace(/%3\$s/g, pagination.currentEndCount)

  return <div className={cx(styles.paginationSummary, className)}>{content}</div>
}

PaginationSummary.propTypes = {
  className: PropTypes.string,
  pagination: PropTypes.instanceOf(Pagination).isRequired,
  format: PropTypes.string.isRequired,
  emptyMessage: PropTypes.string
}

PaginationSummary.defaultProps = {
  className: null,
  emptyMessage: null
}

export default PaginationSummary
